module.exports = __webpack_public_path__ + "img/case3.94de37c3.png";